import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
// import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useState } from "react";
import toRupiah from "../../utils/toRupiah";
import ModalDetailInvoice from "../ModalDetailInvoice/ModalDetailInvoice";
import Button from "@mui/material/Button";
import { ContentGetListInvoice } from "../../constants/types";

interface ICardInvoiceProps {
    data: ContentGetListInvoice;
}

const CardInvoice = ({ data }: ICardInvoiceProps) => {
    const {
        nomorInvoice: noInvoice,
        tanggal: tanggalInvoice,
        uangYangDibayar: hargaPenjualan,
        isReverted,
        metode,
        pgDuitku,
    } = data;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    // const [isOpenModalRevertInvoice, setIsOpenModalRevertInvoice] =
    //     useState(false);
    const [isOpenModalDetailInvoice, setIsOpenModalDetailInvoice] =
        useState(false);
    const [selectedInvoice, setSelectedInvoice] =
        useState<ContentGetListInvoice>({
            id: 0,
            tanggal: "",
            nomorInvoice: "",
            hargaPenjualan: 0,
            uangYangDibayar: 0,
            kembalian: 0,
            isReverted: 0,
            diskon: 0,
            pajak: 0,
            transaksiKe: "",
            kasir: "",
            sales: null,
            metode: null,
            metodeArr: {
                namaMetode: null,
                charge: {
                    mode: null,
                    charge: null,
                },
                noTujuan: null,
                namaPemegang: null,
                gambar: null,
            },
            keterangan: null,
            faktur: {
                idFaktur: 0,
                jumlah: 0,
            },
            isWebstore: null,
            statusWebstore: [],
            pgDuitku: null,
            charge: null,

            pajakPersen: null,

            tipeCharge: null,

            isRefund: 0,
            pelangganWebstore: {
                namaPelanggan: "",
                nomorPelanggan: "",
                pemilikRekening: null,
                rekeningPelanggan: null,
                alamatPelanggan: "",
                provinsi: "",
                kota: "",
                kecamatan: "",
                kelurahan: "",
            },

            detailItem: [],
            mPelangganId: null,
            mPelangganNama: null,
        });

    const openModalDetailInvoice = (data: ContentGetListInvoice) => {
        setSelectedInvoice(data);
        setIsOpenModalDetailInvoice(true);
    };

    const closeModalDetailInvoice = () => {
        setIsOpenModalDetailInvoice(false);
    };

    return (
        <React.Fragment>
            <Card
                variant="outlined"
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 1,
                    padding: isTabletScreen ? 1 : 2,
                }}
            >
                <Box>
                    <Typography fontWeight="bold">{noInvoice}</Typography>
                    <Typography fontSize={12} color="#76747C">
                        {tanggalInvoice}
                    </Typography>
                    <Typography
                        marginTop={1}
                        fontSize={12}
                        fontWeight="bold"
                        color="#76747C"
                    >
                        {isReverted
                            ? "Pembayaran dibatalkan"
                            : hargaPenjualan < 0
                            ? "Laporan pembatalan"
                            : `${
                                  pgDuitku?.method_name ?? metode ?? "Tunai"
                              }: ${toRupiah(
                                  hargaPenjualan + (pgDuitku?.fee ?? 0),
                              )}`}
                    </Typography>
                </Box>
                <Stack direction="row" spacing={2}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            openModalDetailInvoice(data);
                        }}
                        size="small"
                        color="buttongreen"
                        disableElevation
                        sx={{
                            minWidth: "unset",
                            padding: "8px",
                            width: "32px",
                            height: "32px",
                        }}
                    >
                        <VisibilityIcon
                            sx={{ width: "16px", height: "16px" }}
                        />
                    </Button>
                </Stack>
            </Card>
            <ModalDetailInvoice
                data={selectedInvoice}
                fullScreen={fullScreen}
                isOpenModalDetailInvoice={isOpenModalDetailInvoice}
                closeModalDetailInvoice={closeModalDetailInvoice}
            />
        </React.Fragment>
    );
};

export default CardInvoice;
